const AchievementValidator = {
  IS_BET_AMOUNT_GREATER_OR_EQUAL_THAN: 'IS_BET_AMOUNT_GREATER_OR_EQUAL_THAN',
  IS_ODD_GREATER_OR_EQUAL_THAN: 'IS_ODD_GREATER_OR_EQUAL_THAN',
  IS_BET_CENTS_VALID: 'IS_BET_CENTS_VALID',
  IS_LIVE: 'IS_LIVE',
  IS_PREMATCH: 'IS_PREMATCH',
  IS_SPORT_ID_VALID: 'IS_SPORT_ID_VALID',
  IS_CATEGORY_ID_VALID: 'IS_CATEGORY_ID_VALID',
  IS_TOURNAMENT_ID_VALID: 'IS_TOURNAMENT_ID_VALID',
  IS_MATCH_ID_VALID: 'IS_MATCH_ID_VALID',
  IS_BET_TYPE_VALID: 'IS_BET_TYPE_VALID',
  IS_STARTING_BEFORE_MAX_START_DATE: 'IS_STARTING_BEFORE_MAX_START_DATE',
  IS_STARTING_AFTER_MIN_START_DATE: 'IS_STARTING_AFTER_MIN_START_DATE',

  IS_SIMPLE_BET: 'IS_SIMPLE_BET',
  IS_COMBINED_BET: 'IS_COMBINED_BET',
  IS_NOT_SYSTEM: 'IS_NOT_SYSTEM',
  HAS_MYMATCH: 'HAS_MYMATCH',

  IS_MIN_COMBINED_BET_VALID: 'IS_MIN_COMBINED_BET_VALID',
  IS_MIN_MYMATCH_LINE_VALID: 'IS_MIN_MYMATCH_LINE_VALID',
  IS_MIN_ODD_IN_COMBINED_VALID: 'IS_MIN_ODD_IN_COMBINED_VALID',

  IS_CUMULATED_BET_ALLOWED: 'IS_CUMULATED_BET_ALLOWED',
  IS_NB_BET_TO_PLACE_REACHED: 'IS_NB_BET_TO_PLACE_REACHED',
  IS_NB_MAX_RETRY_EXCEEDED: 'IS_NB_MAX_RETRY_EXCEEDED',
  IS_NB_BET_TO_WIN_REACHED: 'IS_NB_BET_TO_WIN_REACHED',
  IS_MATCH_UNIQUE: 'IS_MATCH_UNIQUE',
  IS_CLEAR_MODE_FULFILLED: 'IS_CLEAR_MODE_FULFILLED',

  HAS_FREEBET: 'HAS_FREEBET',
  HAS_BOOSTED_ODDS: 'HAS_BOOSTED_ODDS',
  HAS_OUTRIGHT: 'IS_OUTRIGHT',
  HAS_NO_OUTRIGHT_BUT_BOOSTED_ODDS: 'HAS_NO_OUTRIGHT_BUT_BOOSTED_ODDS',

  HAS_NO_SPORTS_IN: 'HAS_NO_SPORTS_IN',
  HAS_NO_CATEGORIES_IN: 'HAS_NO_CATEGORIES_IN',
  HAS_NO_TOURNAMENTS_IN: 'HAS_NO_TOURNAMENTS_IN',
  HAS_NO_MATCHES_IN: 'HAS_NO_MATCHES_IN',
  HAS_NO_BET_TYPES_IN: 'HAS_NO_BET_TYPES_IN',
};

const MatchStatuses = {
  LIVE: 'LIVE',
  PREMATCH: 'PREMATCH',
};

const BetModes = {
  SIMPLE: 'SIMPLE',
  MYMATCH: 'MYMATCH',
  COMBINED: 'COMBINED',
};

const BasketModes = {
  SIMPLE: 'SIMPLE',
  COMBINED: 'COMBINED',
  SYSTEM: 'SYSTEM',
};

const StatusStates = {
  LIVE: 'LIVE',
  PREMATCH: 'PREMATCH',
};

const ClearModes = {
  PLACED: 'PLACED',
  SETTLED: 'SETTLED',
};

module.exports = {
  AchievementValidator,
  MatchStatuses,
  BetModes,
  BasketModes,
  StatusStates,
  ClearModes,
};
